function validEmail(value) {
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (value) {
        if (value.match(mailformat)) return true;
    }

    return false;
}

export { validEmail };
